import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const ArrowBigRight: IconNode = [
  'svg',
  defaultAttributes,
  [['path', { d: 'M6 9h6V5l7 7-7 7v-4H6V9z' }]],
];

export default ArrowBigRight;
